module.exports = __webpack_public_path__ + "img/img_18_retail@3x.7cc79c93.png";